var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileModal1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "393px",
    height: "653px",
    viewBox: "0 0 393 653",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "boje1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.6901891%",
    y1: "63.5286801%",
    x2: "89.1357466%",
    y2: "59.6320764%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8003F5",
    offset: "17.2799128%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D03F5",
    offset: "37.4835928%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D4863",
    offset: "55.5645872%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8003F5",
    offset: "79.7740473%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131313",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-42.5%",
    y: "-37.6%",
    width: "185.0%",
    height: "175.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website_2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "example-5_mobile",
    transform: "translate(0.000000, -108.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(20.000000, 209.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "boje",
    filter: "url(#filter-2)",
    x: 0,
    y: 26,
    width: 353,
    height: 399
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileModal1);
export default __webpack_public_path__ + "static/media/mobileModal1.d82e092e6ef7aa177f61b5a48e50a639.svg";
export { ForwardRef as ReactComponent };